import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'multireducer';

import { isFetching } from 'shared/selectors/channel-videos';

import {
  loadFirstPage,
  loadMore,
} from 'widget/redux/client/actions/channel-videos-lazy-load';

import DataLoader from 'shared/data-components/_data-loader';


export const DATA_KEY = 'next-videos';
const PER_PAGE_COUNT = 20;


@connect(
  state => ({
    ids: state.lazyVideoLists[DATA_KEY].videoIds,
    nextVideosCursor: state.lazyVideoLists[DATA_KEY].nextVideosCursor,
    isFetching: isFetching(state),
  }),
  dispatch => bindActionCreators({
    loadFirstPage,
    loadMore,
  }, dispatch, DATA_KEY)
)
export default class NextChannelVideosLoader extends DataLoader {
  static displayName = 'NextVideosLoader';

  static propTypes = {
    loadFirstPage: PropTypes.func,
    nextVideosCursor: PropTypes.string,
    channelId: PropTypes.string,
    currentVideoId: PropTypes.string,
  };

  dependencies = [
    'channelId',
    'currentVideoId',
    'nextVideosCursor',
  ];

  get currentIdIndex() {
    const { ids, currentVideoId } = this.props;
    return ids.indexOf(currentVideoId);
  }

  get isAllVideosLoaded() {
    return !this.props.nextVideosCursor;
  }

  get prevVideoId() {
    const { ids } = this.props;
    const currentIdIndex = this.currentIdIndex;

    if (currentIdIndex === -1) {
      return null;
    }

    const prevId = ids[currentIdIndex - 1];

    return prevId || null;
  }

  get nextVideoId() {
    const { ids } = this.props;
    const currentIdIndex = this.currentIdIndex;

    if (currentIdIndex === -1) {
      return null;
    }

    const nextId = ids[currentIdIndex + 1];

    return nextId || null;
  }

  loadData() {
    const { channelId, loadFirstPage, loadMore, ids, currentVideoId, nextVideosCursor } = this.props;

    if (!channelId || !currentVideoId) {
      return;
    }

    if (!ids || !ids.length) {
      return loadFirstPage(PER_PAGE_COUNT, {});
    }

    if (!this.isAllVideosLoaded && !this.nextVideoId) {
      return loadMore(PER_PAGE_COUNT, nextVideosCursor);
    }
  }

  get childProps() {
    const { isFetching, ids } = this.props;
    const { currentIdIndex } = this;

    return {
      nextChannelVideos: {
        prevId: this.prevVideoId,
        nextId: this.nextVideoId,
        loadedVideoIds: ids,
        currentIdIndex,
        isFetching,
      },
    };
  }

}



// WEBPACK FOOTER //
// ./src/widget/data-components/next-channel-videos.js